import { alpha } from '@mui/system';
export var RadioGroupTheme = function (theme) { return ({
    defaultProps: {},
    styleOverrides: {
        root: function (_a) {
            var ownerState = _a.ownerState, theme = _a.theme;
            return ({
                padding: theme.spacing(1),
                input: {
                    '+ span': {
                        display: "inline-flex",
                        alignItems: "center",
                        justifyContent: "center",
                        width: 16,
                        height: 16,
                        borderWidth: 2,
                        borderStyle: 'solid',
                        borderRadius: 16,
                        borderColor: theme.palette.greySecondary[300],
                        boxSizing: "border-box",
                        svg: {
                            display: "none",
                        },
                    },
                },
                '&.Mui-checked': {
                    input: {
                        '+ span': {
                            '&:before': {
                                content: '""',
                                display: "block",
                                width: 8,
                                height: 8,
                                borderRadius: 8,
                                backgroundColor: ownerState.color
                                    ? theme.palette[ownerState.color].main
                                    : theme.palette.greySecondary.main,
                            },
                        },
                    },
                },
                '&.Mui-disabled': {
                    input: {
                        '+ span': {
                            borderColor: alpha(theme.palette.greySecondary.main, 0.16),
                            '&:before': {
                                backgroundColor: alpha(theme.palette.greySecondary.main, 0.48),
                            },
                        },
                    },
                },
            });
        },
    },
}); };
export default RadioGroupTheme;
//# sourceMappingURL=theme.js.map